export default "__VITE_ASSET__CYJTkRCH__"